import APIService from "@/services/APIService.js";

export default {
  getCadernosServicos() {
    return APIService.apiCall().get("/cadernosServicos/getCadernosServicos");
  },
  salvarCaderno(postData) {
    return APIService.apiCall().post(
      `/cadernosServicos/salvar`,
      JSON.stringify(postData)
    );
  },
  deletar(id) {
    return APIService.apiCall().get(`/cadernosServicos/excluir/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/cadernosServicos/baixar/${id}`, {
      responseType: "blob",
      ...config,
    });
  },
  validarHeader(postData) {
    return APIService.apiCall().post(
      `/cadernosServicos/validarHeader`,
      JSON.stringify(postData)
    );
  }
};
